import React, { useEffect, useState, useCallback, useContext } from 'react';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-buttons-dt/js/buttons.dataTables.js';
import 'jszip/dist/jszip.min.js';
import 'pdfmake/build/pdfmake.min.js';
import 'pdfmake/build/vfs_fonts.js';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import { LoginContext } from "../AuthContext/LoginContext";
import { Modal, Button } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import TooltipTextPopupCustom from './child/TooltipTextPopupCustom';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

const TableDataLayerDfos = () => {
    const [dfos, setDfos] = useState([]);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedDFO, setSelectedDFO] = useState(null);
    const [loading, setLoading] = useState(true);
    const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
    const navigate = useNavigate();
    const { hasPermission } = useContext(LoginContext);

    const fetchDfos = useCallback(async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get(`${API_BASE_URL}/backend/forest-employees/all-dfos`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.data.status) {
                setDfos(response.data.data);
            } else {
                toast.error("Failed to fetch DFOs.");
                console.error(response.data.message);
            }
        } catch (error) {
            console.error("Error fetching DFOs:", error);
            toast.error("Error fetching DFOs.");
        } finally {
            setLoading(false);
        }
    }, [API_BASE_URL]);

    useEffect(() => {
        fetchDfos();
    }, [fetchDfos]);

    useEffect(() => {
        let table;
        if (dfos.length > 0 && !$.fn.DataTable.isDataTable('#dataTable')) {
            table = $('#dataTable').DataTable({
                dom: 'Bfrtip',
                buttons: [
                    {
                        extend: 'csv',
                        text: '<i class="iconify" data-icon="mdi:file-delimited-outline"></i> CSV',
                        className: 'btn btn-success btn-sm',
                        exportOptions: {
                            columns: ':visible'
                        }
                    },
                    
                    'colvis'
                ],
                pageLength: 10,
                responsive: true,
                destroy: true,
            });
        }
    
        return () => {
            if (table) {
                table.destroy();
            }
        };
    }, [dfos]);

    const exportToCSV = () => {
        $('#dataTable').DataTable().button('.buttons-csv').trigger();
    };
    
    // const exportToExcel = () => {
    //     $('#dataTable').DataTable().button('.buttons-excel').trigger();
    // };
    
    const exportToPDF = (tableSelector = '#dataTable', fileNamePrefix = 'CMS_Export') => {
        try {
            const table = $(tableSelector).DataTable();
            if (!table) throw new Error("Table not found or not initialized.");
    
            const skipColumnTitles = ['Actions'];
            const headers = [];
            const includedIndexes = [];
    
            // 1. Get visible and valid headers
            table.columns().every(function(index) {
                if (this.visible()) {
                    const column = this;
                    const headerEl = column.header();
                    const headerText = headerEl?.textContent?.trim() || `Column ${index + 1}`;
    
                    if (!skipColumnTitles.includes(headerText)) {
                        headers.push({ title: headerText, index });
                        includedIndexes.push(index);
                    }
                }
                return true;
            });
    
            // 2. Get filtered and sorted data
            const pdfData = [];
            table.rows({ filter: 'applied' }).every(function () {
                const rowEl = this.node(); // Get the actual DOM node for the row
                const cells = rowEl.children;
                const rowValues = [];
    
                includedIndexes.forEach(i => {
                    const cell = cells[i];
                    if (!cell) {
                        rowValues.push('');
                        return;
                    }
    
                    // Get clean visible text without HTML
                    const text = cell.innerText?.trim() || '';
                    rowValues.push(text);
                });
    
                pdfData.push(rowValues);
                return true;
            });
    
            // 3. Create PDF
            const doc = new jsPDF({
                orientation: pdfData.length > 0 && pdfData[0].length > 5 ? 'landscape' : 'portrait',
                unit: 'mm'
            });
    
            const now = new Date();
            const timestamp = now.toISOString()
                .replace(/T/, '_')
                .replace(/\..+/, '')
                .replace(/:/g, '-');
            const fileName = `${fileNamePrefix}_${timestamp}`;
    
            // 4. Title and meta
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(16);
            doc.text(`${fileNamePrefix} Report`, 14, 10);
    
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(10);
            doc.text(`Generated: ${now.toLocaleString()}`, 14, 15);
            doc.text(`Total Records: ${pdfData.length}`, 14, 20);
    
            // 5. Table
            autoTable(doc, {
                startY: 25,
                head: [headers.map(h => h.title)],
                body: pdfData,
                styles: {
                    fontSize: 8,
                    cellPadding: 2,
                    overflow: 'linebreak',
                    halign: 'left'
                },
                headStyles: {
                    fillColor: [41, 128, 185],
                    textColor: 255,
                    fontStyle: 'bold',
                    halign: 'center'
                },
                margin: {
                    top: 25,
                    left: 10,
                    right: 10
                }
            });
    
            // 6. Page numbers
            const pageCount = doc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.setFontSize(8);
                doc.text(
                    `Page ${i} of ${pageCount}`,
                    doc.internal.pageSize.width - 20,
                    doc.internal.pageSize.height - 10
                );
            }
    
            doc.save(`${fileName}.pdf`);
        } catch (error) {
            console.error("PDF Export Error:", error);
            toast.error("Failed to generate PDF. Please try again.");
        }
    };
    

    const handleShowDetailsModal = (dfo) => {
        setSelectedDFO(dfo);
        setShowDetailsModal(true);
    };

    const handleEditDFO = (dfoId) => {
        navigate(`/dfos/update/${dfoId}`);
    };

    const handleShowDeleteModal = (dfo) => {
        setSelectedDFO(dfo);
        setShowDeleteModal(true);
    };

    const handleDeleteDFO = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.patch(
                `${API_BASE_URL}/backend/users/delete/${selectedDFO._id}`,
                {},
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );

            if (response.data.status) {
                toast.success("DFO deleted successfully.");
                fetchDfos();
            } else {
                toast.error("Failed to delete DFO.");
            }
        } catch (error) {
            console.error("Error deleting DFO:", error);
            toast.error("Error deleting DFO.");
        } finally {
            setShowDeleteModal(false);
        }
    };

    return (
        <div className="card basic-data-table">
            <ToastContainer />
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">DFO Data</h5>
                <div className="export-buttons d-flex align-items-center">
                    <button onClick={exportToCSV} className="btn btn-success btn-sm me-2 d-flex align-items-center">
                        <Icon icon="mdi:file-delimited-outline" className="me-1" style={{ fontSize: '16px' }} /> 
                        CSV
                    </button>
                    {/* <button onClick={exportToExcel} className="btn btn-primary btn-sm me-2 d-flex align-items-center">
                        <Icon icon="mdi:microsoft-excel" className="me-1" style={{ fontSize: '16px' }} /> 
                        Excel
                    </button> */}
                    <button onClick={() => exportToPDF('#dataTable', 'DFOs_Export')} className="btn btn-danger btn-sm me-2 d-flex align-items-center">
                        <Icon icon="mdi:file-pdf-box" className="me-1" style={{ fontSize: '16px' }} /> 
                        PDF
                    </button>
                    {/* <button onClick={printTable} className="btn btn-info btn-sm d-flex align-items-center">
                        <Icon icon="mdi:printer" className="me-1" style={{ fontSize: '16px' }} /> 
                        Print
                    </button> */}
                </div>
            </div>
            <div className="card-body">
                <div className="table-responsive">
                    <table className="table bordered-table mb-0" id="dataTable" data-page-length={10}>
                        <thead>
                            <tr>
                                <th scope="col">S.L</th>
                                <th scope="col">Name</th>
                                <th scope="col">Designation</th>
                                <th scope="col">Place of Posting</th>
                                <th scope="col">Contact No</th>
                                <th scope="col">Email</th>
                                <th scope="col">Address</th>
                                <th scope="col">Emergency Contact Number</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                Array.from({ length: 10 }).map((_, index) => (
                                    <tr key={index}>
                                        <td><Skeleton width={30} /></td>
                                        <td><Skeleton width={120} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={150} /></td>
                                        <td><Skeleton width={150} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={30} /></td>
                                    </tr>
                                ))
                            ) : dfos && dfos.length > 0 ? (
                                dfos.map((dfo, index) => (
                                    <tr key={dfo._id}>
                                        <td>{index + 1}</td>
                                        <td>{dfo.first_name} {dfo.last_name}</td>
                                        <td>{dfo.designation}</td>
                                        <td>{dfo.place_of_posting}</td>
                                        <td>{dfo.phone_no}</td>
                                        <td>{dfo.email}</td>
                                        <td>
                                             <TooltipTextPopupCustom 
                                                text={dfo.address}
                                                truncateLength={16} 
                                                placement="left"
                                                customClass="tooltip-info" />
                                        </td>
                                        <td>{dfo.emergency_contact_number || 'No Data Found'}</td>
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-10 justify-content-center">
                                                {hasPermission('dfo_list', 'view') && (
                                                    <button
                                                        type="button"
                                                        onClick={() => handleShowDetailsModal(dfo)}
                                                        className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    >
                                                        <Icon
                                                            icon="majesticons:eye-line"
                                                            className="icon text-xl"
                                                        />
                                                    </button>
                                                )}
                                                {hasPermission('dfo_list', 'edit') && (
                                                    <button
                                                        onClick={() => handleEditDFO(dfo._id)}
                                                        type="button"
                                                        className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    >
                                                        <Icon icon="lucide:edit" className="menu-icon" />
                                                    </button>
                                                )}
                                                {hasPermission('dfo_list', 'delete') && (
                                                    <button
                                                        type="button"
                                                        onClick={() => handleShowDeleteModal(dfo)}
                                                        className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    >
                                                        <Icon
                                                            icon="fluent:delete-24-regular"
                                                            className="menu-icon"
                                                        />
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" className="text-center">No DFOs found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* DFO Details Modal */}
            <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>DFO Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedDFO && (
                        <div>
                            <p><strong>Name:</strong> {selectedDFO.name}</p>
                            <p><strong>Designation:</strong> {selectedDFO.designation}</p>
                            <p><strong>Place of Posting:</strong> {selectedDFO.place_of_posting}</p>
                            <p><strong>Contact No:</strong> {selectedDFO.contact_no}</p>
                            <p><strong>Email:</strong> {selectedDFO.email}</p>
                            <p><strong>Office Address:</strong> {selectedDFO.office_address || 'No Data Found'}</p>
                            <p><strong>Office Contact Number:</strong> {selectedDFO.office_contactnumber || 'No Data Found'}</p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDetailsModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete {selectedDFO?.name || 'this DFO'}?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDeleteDFO}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default TableDataLayerDfos;